import { ActiveIngredientForAdminMedicineModel } from "../activeIngredient/activeIngredientForAdminMedicineModel";
import { InactiveIngredientModel } from "../inactiveIngredient/inactiveIngredientModel";
import { FileModel } from "../../models/fileModel";
import { ATCCodeModel } from "../atcCode";
import { ManufacturerAdminModel } from "../manufacturer";
import { ImportAdminMedicineContentModel } from "../../models/dataSynchronization";
import { DosageContentModel } from "../dosage/dosageContentModel";
import { IngredientSideEffectModel } from "../sideEffect/ingredientSideEffectModel";
import { AdminMedicineSpecificationModel } from "../medicine/adminMedicineSpecificationModel";
import { PregnancyAndBreastfeedingModel } from "../medicine/pregnancyAndBreastfeedingModel";
import { DriveAndMachineModel } from "../medicine/driveAndMachineModel";
import { SafetyDataModel } from "../medicine/safetyDataModel";
import { MedicineInteractionContentModel } from "../medicine/medicineInteractionContentModel";

export class ImportAdminMedicineModel {
  public syncMedicineDataId: number;
  public brandName: string;
  public authorizationStatusId: number;
  public emaProductNumber: string;
  public emaMedicineURL: string;
  public dataSourceTypeId: number;
  public atcCode?: ATCCodeModel;
  public authorizationHolder: ManufacturerAdminModel;
  public manufacturer: ManufacturerAdminModel;
  public activeIngredients: Array<ActiveIngredientForAdminMedicineModel>;
  public inactiveIngredients: Array<InactiveIngredientModel>;
  public adminMedicineContents: Array<ImportAdminMedicineContentModel>;
  public leaflets: Array<FileModel>;
  public leafletIds: Array<number>;
  public dosageContent: DosageContentModel;
  public sideEffect: IngredientSideEffectModel;
  public medicineSpecification: AdminMedicineSpecificationModel;
  public pregnancyAndBreastfeeding: PregnancyAndBreastfeedingModel;
  public driveAndMachine: DriveAndMachineModel;
  public safetyData: SafetyDataModel;
  public medicineInteractionContents: Array<MedicineInteractionContentModel>;
}